import { http } from '@/lib/http';
import type {
  InitiatedPaymentResponse,
  Payment,
  PaymentProvider,
  PaymentStatus,
} from '@/types/payments';

const BASE = '/api/v1/payments';

export interface PaymentListQuery {
  status?: PaymentStatus;
  provider?: PaymentProvider;
  salesOrderId?: string;
  externalPaymentRef?: string;
  page?: number;
  pageSize?: number;
}

export interface PaymentListResponse {
  rows: Payment[];
  page: number;
  pageSize: number;
  total: number;
}

export interface InitiatePaymentPayload {
  salesOrderId: string;
  provider?: PaymentProvider;
  externalPaymentRef?: string;
  amount?: number;
  currency?: string;
  metadata?: Record<string, unknown>;
}

export interface UpdatePaymentStatusPayload {
  status: PaymentStatus;
  reason?: string;
  providerPaymentId?: string;
}

export const paymentsService = {
  list: (query: PaymentListQuery = {}) =>
    http.get<PaymentListResponse>(BASE, { params: query }),
  get: (id: string) => http.get<Payment>(`${BASE}/${id}`),
  initiate: (payload: InitiatePaymentPayload) =>
    http.post<InitiatedPaymentResponse, InitiatePaymentPayload>(
      `${BASE}/initiate`,
      payload,
    ),
  updateStatus: (id: string, payload: UpdatePaymentStatusPayload) =>
    http.patch<Payment, UpdatePaymentStatusPayload>(`${BASE}/${id}/status`, payload),
};
